<template>
  <el-row class="bottom-footer">
    <el-col :span="12" :offset="6">
      <span><i class="fa fa-copyright"></i> 召必回车服 | 联系 <a href="tel:19922129951">19922129951</a></span>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'bottom-footer'
}
</script>

<style scoped>
  .bottom-footer {
    background: #676f77;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 30px;
    clear: both;
    line-height: 30px;
    font-size: 13px;
    z-index: 1010;
    color: white;
  }
  a {
    color: #bbb;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/BottomFooter.vue